import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';
import GridCategoriesSkeleton from './grid-skeleton';

// 去掉ssr主要是为了首页CLS过高问题
const CategoriesFilterListMain = dynamic(() => import('./categories-list'), {
  loading: Skeleton
});

const GridCategoriesFilterListMain = dynamic(() => import('./grid-categories-list'), {
  loading: GridCategoriesSkeleton
});

const CategoriesFilterList = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  let isGridStyle = props.properties?.style === 'grid';

  const skeleton = isGridStyle ? (
    <GridCategoriesSkeleton cmsComponentKey={props.cmsComponentKey} />
  ) : (
    <Skeleton cmsComponentKey={props.cmsComponentKey} />
  );

  if (props.data) {
    if (isGridStyle) {
      return <GridCategoriesFilterListMain skeleton={skeleton} {...props} />;
    }
    return <CategoriesFilterListMain skeleton={skeleton} {...props} />;
  }

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  if (isGridStyle) {
    return <GridCategoriesFilterListMain skeleton={skeleton} {...props} />;
  }

  return <CategoriesFilterListMain skeleton={skeleton} {...props} />;
};

export default CategoriesFilterList;
